import React, { FC } from "react";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { useAppDispatch } from "toolkit/hooks";
import { restoreFolder } from "toolkit/documents/folders/folders.thunks";
import styles from "./RestoringFolder.module.sass";

interface RestoringFolderProps {
	folderId: number;
	close: () => void;
}

export const RestoringFolder: FC<RestoringFolderProps> = ({ folderId, close }) => {
	const dispatch = useAppDispatch();

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		dispatch(restoreFolder({ folderId }));
		close();
	};

	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>Вы уверены?</h4>
			<span className={styles.subtitle}>
				Восстановится папка и <span className={styles.bold}>её содержимое</span>
			</span>
			<form onSubmit={submitHandler} className={styles.form}>
				<div className={styles.btns}>
					<Button onClick={close} type="button" variant={BUTTON_VARIANTS.OUTLINED} className={styles.button}>
						Отмена
					</Button>
					<Button type="submit" className={styles.button}>
						Восстановить
					</Button>
				</div>
			</form>
		</section>
	);
};
